export default __webpack_public_path__ + "static/media/a1659d4c966829fdba22456b40a2399c.svg";